"use client";

import { createFileRoute, redirect } from "@tanstack/react-router";
import { isPhaseKey } from "@/lib/hundert-tage";

/**
 * Frühere Phasenseite: Die Aufgaben stehen jetzt direkt unter der Zeitachse.
 * Bestehende Adressen aus Begleitmails und Lesezeichen bleiben gültig und
 * leiten auf die Übersicht mit vorgewählter Phase.
 */
export const Route = createFileRoute("/_cockpit/cockpit/hundert-tage/$phase")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/cockpit/hundert-tage",
      search: isPhaseKey(params.phase) ? { phase: params.phase } : {},
      hash: isPhaseKey(params.phase) ? "hundert-tage-aufgaben" : undefined,
      replace: true,
    });
  },
});
